module.exports = __webpack_public_path__ + "img/mobil.f4f2d9c1.png";